<template>
    <div class="disconnected center flex" :class="retry < 8 ? 'bg-transparent' : ''" v-if="!connected">
        <template v-if="retry >= 8">
            <div class="overlay" />
            <div class="message">{{ 'DISCONNECTED' | translate }}</div>
            <button @click="manualReconnect" class="btn btn-primary flex-wrap">{{ 'RECONNECT' | translate }}</button>
        </template>

        <template v-else>
            <!-- <div class="overlay" /> -->
            <div class="loading-container">
                <div :class="'dot-falling'" />
            </div>
            <div class="loading-message">서버에 접속중입니다.</div>
        </template>
    </div>
</template>

<script>
export default {
    data: () => ({
        retry: 0,
        reconnectTimer: null, // 타이머 저장용
        isReconnecting: false, // 중복 방지 플래그
        reconnectInProgress: false, // ✅ 추가
    }),
    computed: {
        connected() {
            return this.$store.getters.connected
        },
    },
    // watch: {
    //     connected() {
    //         this.reconnect()
    //     },
    // },
    mounted() {
        // this.reconnect() // 컴포넌트 마운트 시 자동 연결 시도
        // if (!this.connected) {
        //     this.reconnect() // 컴포넌트 마운트 시 자동 연결 시도
        // }
    },
    watch: {
        connected(val) {
            console.log('watch connected', val, this.retry)

            clearTimeout(this.reconnectTimer) // 루프 문제 해결

            if (val) {
                // 연결되었으면 안정적일 때만 retry 리셋
                const debounceTime = this.retry < 4 ? 1500 : 2000
                this.reconnectTimer = setTimeout(() => {
                    if (this.connected) {
                        console.log('[Debounced Connected] 연결 안정적으로 확인됨')
                        this.retry = 0
                        this.isReconnecting = false
                    } else {
                        console.log('[Debounced Connected] false로 떨어져서 무시함')
                    }
                }, debounceTime) // 1초 동안 연결이 유지되면 진짜 성공으로 간주

                // this.retry = 0 // 연결되었으면 재시도 카운트 리셋
                // this.isReconnecting = false
                // clearTimeout(this.reconnectTimer) // 타이머 제거
            } else if (this.retry < 8 && !this.isReconnecting) {
                this.scheduleReconnect() // 재연결 스케줄링
            }
        },
    },
    methods: {
        reconnect() {
            // console.log('[RECONNECT]', this.connected, this.retry, this.isReconnecting)
            if (this.connected || this.retry >= 8 || this.isReconnecting || this.reconnectInProgress) {
                console.log('연결 성공 또는 재시도 한계 도달')
                return
            }

            this.reconnectInProgress = true

            this.isReconnecting = true
            console.trace(`🔄 [재시도 ${this.retry + 1}/8] WebSocket 재연결 시도...`)
            this.$bus.$emit('onRequestReconnect') // 얘가 promise 형태로 반환 안해줘서 문제가됨...
            this.retry++

            // 1초 후에 재시도 (최대 8번)
            if (this.retry < 8) {
                this.reconnectTimer = setTimeout(() => {
                    this.isReconnecting = false
                    this.reconnectInProgress = false // ✅ 여기서 해제
                    this.reconnect()
                    // }, this.retry * 1000)
                }, Math.max(this.retry * 1000, 3000))
            } else {
                this.isReconnecting = false
            }
        },
        scheduleReconnect() {
            clearTimeout(this.reconnectTimer) // 기존 타이머 클리어
            this.reconnectTimer = setTimeout(() => {
                this.reconnect()
            }, 1000)
        },
        manualReconnect() {
            console.log('사용자가 수동 재연결 요청')
            this.retry = 0 // 사용자가 수동 요청하면 재시도 횟수 리셋
            this.reconnect()
        },
    },
    beforeDestroy() {
        clearTimeout(this.reconnectTimer) // 컴포넌트가 제거될 때 타이머 해제
    },
}
</script>
